import type { MaybeRef } from "vue"
import { useMutation } from "@tanstack/vue-query"
import { toValue } from "vue"
import { v1 } from "@/axios"

export interface ExportRsvpListResponse {
  blob: Blob
  filename: string
  contentType: string
}

export async function exportRsvpList(eventVaultId: number): Promise<ExportRsvpListResponse> {
  const response = await v1.get(`/events/${eventVaultId}/rsvp/export`, {
    responseType: "blob",
  })

  const contentType = (response.headers["content-type"] as string) || "text/csv"
  const blob = new Blob([response.data], { type: contentType })

  return {
    blob,
    filename: `rsvp-list-${eventVaultId}.csv`,
    contentType,
  }
}

export const EXPORT_RSVP_LIST = "exportRsvpList"

export function useExportRsvpList(eventVaultId?: MaybeRef<number | undefined>) {
  return useMutation({
    mutationKey: [EXPORT_RSVP_LIST, eventVaultId],
    mutationFn: () => exportRsvpList(toValue(eventVaultId)!),
  })
}
